@import (reference) '../../../../../../../constants/spacing.module.less';

.upsell-container {
  padding: @space-0 @space-16 @space-16;
}

.banner {
  background-color: var(--purple-100);
  border: 1px solid var(--purple-300);
  border-radius: @space-8;
  padding: @space-16 @space-24;
  margin-bottom: @space-24;
  align-items: center;
}

.banner-icon {
  color: var(--purple-700);
  flex-shrink: 0;
  align-self: center;
}

.banner-text {
  flex: 1;
}

.banner-title {
  color: var(--gray-0F0F10);
  font-weight: 600;
}

.banner-subtitle {
  color: var(--gray-637381);
  margin-top: @space-4;
}

.disabled-preview {
  opacity: 0.5;
  pointer-events: none;
  user-select: none;
}

.preview-card {
  background-color: var(--white);
  border: 1px solid var(--default--border-color--10);
  border-radius: @space-4;
  padding: @space-16;
}

.preview-header {
  justify-content: space-between;
  align-items: flex-start;
  gap: @space-16;
  margin-bottom: @space-16;
}

.preview-subtitle {
  padding: @space-4 @space-0 @space-12;
}

.print-btn {
  white-space: nowrap;
  flex-shrink: 0;
}

.grid {
  margin-top: @space-8;
  border: 1px solid var(--gray-DFE4E8);
  border-radius: @space-4;
  overflow: hidden;
}

.grid-header,
.grid-row {
  display: grid;
  grid-template-columns: 60px 80px 1fr 1fr 120px 60px 60px;
  column-gap: @space-8;
  padding: @space-8 @space-12;
  align-items: center;
}

.grid-header {
  background-color: var(--gray-F4F6F8);
  border-bottom: 1px solid var(--gray-DFE4E8);
  font-weight: 500;
}

.grid-row {
  color: var(--gray-45505B);
}

.grid-cell-dash {
  color: var(--gray-9EA6AD);
}

.add-unit-row {
  padding: @space-8 @space-0;
  color: var(--blue-600);
}

.add-unit-icon {
  margin-right: @space-4;
}

.conversion-summary {
  margin-top: @space-16;
  padding: @space-12 @space-16;
  background-color: var(--gray-F4F6F8);
  border-radius: @space-4;
  border: 1px solid var(--gray-CFD1D3);
}

.conversion-title {
  color: var(--gray-0F0F10);
  margin-bottom: @space-8;
  font-weight: 500;
}

.conversion-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.conversion-item {
  display: block;
  color: var(--gray-637381);
  padding: @space-4 @space-0;
}
